import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDTn-jKoINVifjCKo8eHAP8ozGsCdq2eao",
  authDomain: "prompt-dataset.firebaseapp.com",
  projectId: "prompt-dataset",
  storageBucket: "prompt-dataset.appspot.com",
  messagingSenderId: "1090729186728",
  appId: "1:1090729186728:web:e99b768beea5e1ce55b99d",
  measurementId: "G-8XMB1L451G",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app, "automations");
export const auth = getAuth(app);
